"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialValues = exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdFormik = require("cccisd-formik");
var _cccisdLaravelAppdefs = require("cccisd-laravel-appdefs");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var initialValues = exports.initialValues = {
  show: true,
  title: 'Measurement Information',
  description: '<div>Define how overall fidelity is calculated, how lowest and highest sessions are determined, and how results are interpreted. Data displayed in this report are drawn from the following groups only.</div>'
};
var Component = function Component(props) {
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "show",
    component: _cccisdFormik.CccisdToggle,
    label: "Show Info Tab?"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "title",
    component: _cccisdFormik.CccisdInput,
    label: "Title"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "description",
    component: _cccisdFormik.CccisdWysiwyg,
    label: "Description"
  }));
};
var _default = exports["default"] = (0, _cccisdLaravelAppdefs.widgetBuilder)({
  initialValues: initialValues
})(Component);